import React from "react";
import Home from "./../pages/Home.js";
import LoginV3 from "./../pages/login-v3.js";
import RegisterV3 from "./../pages/register-v3.js";
import EmailConfirm from "./../pages/email-confirm.js";
import EmailConfirmed from "./../pages/email-confirmed.js";
import PasswordRequest from "./../pages/password-request.js";
import PasswordReset from "./../pages/password-reset.js";
import SelectLevel from "./../pages/select_level.js";
import RegentInscription from "./../pages/regent-inscription";
import RepresentanteInscripcion from "./../pages/representante-inscription";
import Tramites from "./../pages/tramites.js";
import Applications from "./../pages/applications.js";
import SolicitudesDISAAN from "./../pages/solicitudes_disaan.js";
import Profile from "./../pages/profile.js";
import EditProfile from "./../pages/edit-profile";
import Reports from "./../pages/reports.js";
import Catalogs from "../pages/catalogs.js";
import LicensePrint from "../pages/license-print.js";
import LicenseDISAANPrint from "../pages/license-disaan-print.js";
import EstablishmentInscription from "../pages/establishment-inscription.js";
import EstablishmentEdition from "../pages/establishment-edition.js";
import DemoGrid from "../pages/demogrid.js";
import PayOrders from "../pages/pay_orders.js";
import ReceiptRequest from "../pages/Receipt_request.js";
import Users from "../pages/users.js";
import Notifications from "../pages/notifications.js";
import Establecimientos from "../pages/establecimientos.js";
import SolicitudAL from "../pages/solicitudesAsesoria.js";
import Product from "../pages/product-inscription.js";
import ProductList from "../pages/products.js";
import Quizzes from "../pages/quizzes.js";
import DescargarAPKAPP from "../pages/DescargarAPKAPP.js";
import Visits from "../pages/visits.js";
import ElectronicPrescription from "../pages/electronic-prescription.js";
import ElectronicPrescriptionList from "../pages/electronic-prescription-list.js";
import PrescriptionSupply from "../pages/prescription-supply.js";
import PrescriptionList from "../pages/prescription-list.js";
import ProductMovemetsExit from "../pages/product-movements-exit.js";
import ProductMovemetsIncome from "../pages/product-movements-income.js";
import ProductsClient from "../pages/product-client.js";
import ProductMovemetsHistory from "../pages/product-movements-history.js";
import ProductInventory from "../pages/product-inventory.js";
import MoveProduct from "../pages/product-move.js";
import Sustancias from "../pages/sustancias.js";
import Activity from "../pages/activity-inscription.js";
import ActivitiesList from "../pages/activities.js";
import DenunciasPublicas from "../pages/denuncias_publicas";
import Regencia from "../pages/regencia";
import SubstanceReport from "../pages/substance-reports";
import Inventory from "../pages/inventory-inscription";
import InventoryList from "../pages/inventory";
import VeterinarianInscription from "../pages/veterinarian-inscription.js";
import EstablecimientosCuarentena from "../pages/establecimientos-cuarentena";
import Sanciones from "../pages/sanciones";
import ProductEdit from "../pages/product-edit.js";
import ProductsAM from "../pages/products-am.js";
import EstAssoc from "../pages/establishment-association.js";
import Certificate from "../pages/certificate.js";
import PreCertificate from "../pages/precertificate.js";
import AsoPlanta from "../pages/asociar-planta.js";
import Comercializadores from "../pages/comercializadores.js";
import AssociateMedic from "../pages/associate-medical.js";
import PrecertificadoCE from "../pages/precertificadoCE";
import SolicitudesMedico from "../pages/solicitudes_medico";
import ImpresionMedico from "../pages/impresion_medico";
import OrdenesPrecertificados from "../pages/orden-pago-precertificados.js";
import SpecialCases from "../pages/special-cases.js";
import Boletinage from "../pages/boletinaje.js";
import ProductWithdrawal from "../pages/product-withdrawal.js";
import AutorizacionAdquisicion from "../pages/autorizacion-adquisicion.js";
import ListaEstablecimientosRepReg from "../pages/lista-establecimientos-regrep.js";
import ListaEstablecimientos from "../pages/lista-establecimientos.js";
import Metas from "../pages/metas.js";
import MetasIPSA from "../pages/metas-IPSA.js";
import VisualizacionIPSA from "../pages/visualizacion-IPSA.js";
import ClasificacionProductos from "../pages/products-classification.js";
import SustanciasReporte from "../pages/sustancias-reporte-formulario.js";
import SustanciasLista from "../pages/sustancia-reporte-lista.js";
import ListaSustanciasGral from "../pages/sustancia-reporte-general.js";
import SustanciaReporteControlado from "../pages/sustancia-reporte-medicamento-controlado.js";
import ReportesMain from "../pages/reportes-main.js";
import AutorizacionAlimentosCuarentena from "../pages/autorizacion-alimentos-cuarentena.js";
import VisitDrycip from "../pages/visit-drycip.js"
import ProductsCuarentena from "../pages/products-cuarentena.js"

const routes = [
  {
    path: "/",
    exact: true,
    title: "Inicio",
    component: () => <Home />,
  },
  {
    path: "/login",
    exact: true,
    title: "Acceder",
    component: () => <LoginV3 />,
  },
  {
    path: "/register",
    exact: true,
    title: "Registro",
    component: () => <RegisterV3 />,
  },
  {
    path: "/confirm",
    exact: true,
    title: "Confirmar email",
    component: () => <EmailConfirm />,
  },
  {
    path: "/confirmed/*",
    exact: true,
    title: "Confirmar email",
    component: () => <EmailConfirmed />,
  },
  {
    path: "/password-request/",
    exact: true,
    title: "Solicitar cambio de contraseña",
    component: () => <PasswordRequest />,
  },
  {
    path: "/password-reset/*",
    exact: true,
    title: "Reiniciar contraseña",
    component: () => <PasswordReset />,
  },
  {
    path: "/solicitud/inscripcion-regente",
    exact: true,
    title: "Inscripción regente",
    component: () => <RegentInscription />,
  },
  {
    path: "/solicitud/inscripcion-representante",
    exact: true,
    title: "Inscripción representante legal",
    component: () => <RepresentanteInscripcion />,
  },
  {
    path: "/tramites",
    exact: true,
    title: "Consulta trámites",
    component: () => <Tramites />,
  },
  {
    path: "/seleccionar-nivel",
    exact: true,
    title: "Selección nivel",
    component: () => <SelectLevel />,
  },
  {
    path: "/solicitudes/drycip",
    exact: true,
    title: "Solicitudes",
    component: () => <Applications />,
  },
  {
    path: "/solicitudes/disaan",
    exact: true,
    title: "Solicitudes",
    component: () => <SolicitudesDISAAN />,
  },
  {
    path: "/perfil",
    exact: true,
    title: "Perfil",
    component: () => <Profile />,
  },
  {
    path: "/perfil-editar",
    exact: true,
    title: "Editar perfil",
    component: () => <EditProfile />,
  },
  {
    path: "/reporte",
    exact: true,
    title: "Reportes",
    component: () => <Reports />,
  },
  {
    path: "/impresion_licencias",
    exact: true,
    title: "Impresión licencias",
    component: () => <LicensePrint />,
  },
  {
    path: "/disaan/impresion_licencias",
    exact: true,
    title: "Impresión licencias",
    component: () => <LicenseDISAANPrint />,
  },
  {
    path: "/catalogos",
    exact: true,
    title: "Catálogos",
    component: () => <Catalogs />,
  },
  {
    path: "/solicitud/inscripcion-establecimiento/:id",
    exact: true,
    title: "Registro de establecimiento",
    component: () => <EstablishmentInscription />,
  },
  {
    path: "/establecimiento/:id/:solid",
    exact: true,
    title: "Edicion de establecimiento",
    component: () => <EstablishmentEdition />,
  },
  {
    path: "/demogrid",
    exact: true,
    title: "Demo de grid",
    component: () => <DemoGrid />,
  },
  {
    path: "/ordenes",
    exact: true,
    title: "Órdenes",
    component: () => <PayOrders />,
  },
  {
    path: "/solicitud-tramites",
    exact: true,
    title: "Solicitud de trámites",
    component: () => <ReceiptRequest />,
  },
  {
    path: "/regencia",
    exact: true,
    title: "Regencia",
    component: () => <Regencia />,
  },
  {
    path: "/reportes-medicamento",
    exact: true,
    title: "Reportes Medicamento",
    component: () => <SubstanceReport />,
  },
  {
    path: "/usuarios",
    exact: true,
    title: "Usuarios",
    component: () => <Users />,
  },
  {
    path: "/notificaciones",
    exact: true,
    title: "Notificaciones",
    component: () => <Notifications />,
  },
  {
    path: "/establecimientos/listado",
    exact: true,
    title: "Establecimientos",
    component: () => <Establecimientos />,
  },
  {
    path: "/solicitudesEstablecimientos",
    exact: true,
    title: "Solicitudes",
    component: () => <SolicitudAL />,
  },
  {
    path: "/solicitud/inscripcion-producto/:tipo_producto_id/:id",
    exact: true,
    title: "Productos",
    component: () => <Product />,
  },
  {
    path: "/productos/listado",
    exact: true,
    title: "Solicitudes",
    component: () => <ProductList />,
  },

  {
    path: "/fiscalizacion",
    exact: true,
    title: "Fiscalización",
    component: () => <Quizzes />,
  },
  {
    path: "/visitas",
    exact: true,
    title: "Visitas",
    component: () => <Visits />,
  },
  {
    path: "/recetas-electronicas/expedir",
    exact: true,
    title: "Expedir Receta",
    component: () => <ElectronicPrescription />,
  },
  {
    path: "/asociar-medico-comercializador",
    exact: true,
    title: "Asociar médico a establecimiento",
    component: () => <AssociateMedic />,
  },
  {
    path: "/recetas-electronicas/expedidas",
    exact: true,
    title: "Recetas Expedidas",
    component: () => <ElectronicPrescriptionList />,
  },
  {
    path: "/recetas-electronicas/surtidas",
    exact: true,
    title: "Recetas Surtidas",
    component: () => <PrescriptionList />,
  },
  {
    path: "/recetas-electronicas/surtir",
    exact: true,
    title: "Surtir Receta",
    component: () => <PrescriptionSupply />,
  },
  {
    path: "/movimientos-productos/egresos",
    exact: true,
    title: "Egresos",
    component: () => <ProductMovemetsExit />,
  },
  {
    path: "/movimientos-productos/ingresos",
    exact: true,
    title: "Ingresos",
    component: () => <ProductMovemetsIncome />,
  },
  {
    path: "/productos/activos",
    exact: true,
    title: "Activos",
    component: () => <ProductsClient />,
  },
  {
    path: "/movimientos-productos/historial",
    exact: true,
    title: "Historial",
    component: () => <ProductMovemetsHistory />,
  },
  {
    path: "/movimientos-productos/inventario",
    exact: true,
    title: "Inventario",
    component: () => <ProductInventory />,
  },
  {
    path: "/movimientos-productos/mover-producto",
    exact: true,
    title: "Mover producto",
    component: () => <MoveProduct />,
  },
  {
    path: "/sustancias",
    exact: true,
    title: "Sustancias",
    component: () => <Sustancias />,
  },
  {
    path: "/actividades/registro",
    exact: true,
    title: "Registro",
    component: () => <Activity />,
  },
  {
    path: "/actividades/lista",
    exact: true,
    title: "Lista",
    component: () => <ActivitiesList />,
  },
  {
    path: "/denuncias-publicas",
    exact: true,
    title: "Denuncias públicas",
    component: () => <DenunciasPublicas />,
  },
  {
    path: "/inventario/alta",
    exact: true,
    title: "Alta inventario",
    component: () => <Inventory />,
  },
  {
    path: "/inventario/lista",
    exact: true,
    title: "Lista inventario",
    component: () => <InventoryList />,
  },
  {
    path: "/solicitud/inscripcion-medico-veterinario",
    exact: true,
    title: "Inscripción médico veterinario",
    component: () => <VeterinarianInscription />,
  },
  {
    path: "/establecimientos-cuarentena",
    exact: true,
    title: "Establecimientos cuarentena",
    component: () => <EstablecimientosCuarentena />,
  },
  {
    path: "/sanciones",
    exact: true,
    title: "Sanciones",
    component: () => <Sanciones />,
  },
  {
    path: "/solicitud/editar-producto/:tipo_producto_id/:id/:solicitud_id",
    exact: true,
    title: "Editar producto",
    component: () => <ProductEdit />,
  },
  {
    path: "/productos/anotacion-marginal",
    exact: true,
    title: "Anotación marginal productos",
    component: () => <ProductsAM />,
  },
  {
    path: "/productos/baja",
    exact: true,
    title: "Baja",
    component: () => <ProductWithdrawal />,
  },
  {
    path: "/asociar-establecimiento",
    exact: true,
    title: "Establecimientos cuarentena",
    component: () => <EstAssoc />,
  },
  {
    path: "/productos/certificados",
    exact: true,
    title: "Certificados",
    component: () => <Certificate />,
  },
  {
    path: "/productos/precertificados",
    exact: true,
    title: "Precertificados",
    component: () => <PreCertificate />,
  },
  {
    path: "/comercializador/asociar",
    exact: true,
    title: "Asociar a planta",
    component: () => <AsoPlanta />,
  },
  {
    path: "/comercializadores",
    exact: true,
    title: "Lista comercializadores",
    component: () => <Comercializadores />,
  },
  {
    path: "/subproductos/precertificado-constancia-exportacion",
    exact: true,
    title: "Precertificado costancias de expotación",
    component: () => <PrecertificadoCE />,
  },
  {
    path: "/ordenes-pago-precertificados",
    exact: true,
    title:
      "Créditos para solicitar precertificado y/o constancias de exportación",
    component: () => <OrdenesPrecertificados />,
  },
  {
    path: "/Solicitudes-medico",
    exact: true,
    title: "Solicitudes medico",
    component: () => <SolicitudesMedico />,
  },
  {
    path: "/impresiones-medico-veterinario",
    exact: true,
    title: "Impresión",
    component: () => <ImpresionMedico />,
  },
  {
    path: "/solicitud-casos-especiales",
    exact: true,
    title: "Solicitud de casos especiales",
    component: () => <SpecialCases />,
  },
  {
    path: "/notificacionesBoletin",
    exact: true,
    title: "Notificaciones",
    component: () => <Boletinage />,
  },
  {
    path: "/subproductos/autorizacion-de-adquisicion",
    exact: true,
    title: "Autorización de adquisición",
    component: () => <AutorizacionAdquisicion />,
  },
  {
    path: "/establecimientos-activos",
    exact: true,
    title: "Establecimientos activos",
    component: () => <ListaEstablecimientosRepReg />,
  },
  {
    path: "/establecimientos",
    exact: true,
    title: "Establecimientos",
    component: () => <ListaEstablecimientos />,
  },
  {
    path: "/Metas",
    exact: true,
    title: "Metas",
    component: () => <Metas />,
  },
  {
    path: "/Metas/Metas-POA",
    exact: true,
    title: "Metas",
    component: () => <MetasIPSA />,
  },
  {
    path: "/Metas/visualizacion-reportes-poa",
    exact: true,
    title: "Visualización de reportes",
    component: () => <VisualizacionIPSA />,
  },
  {
    path: "/Clasificacion-productos",
    exact: true,
    title: "Clasificación de productos",
    component: () => <ClasificacionProductos />,
  },
  {
    path: "/reportes-importacion",
    exact: true,
    title: "Reporte de sustancias",
    component: () => <SustanciasLista />,
  },
  {
    path: "/reportes-importacion-general",
    exact: true,
    title: "Reporte de sustancias",
    component: () => <ListaSustanciasGral />,
  },
  {
    path: "/reportar-importacion",
    exact: true,
    title: "Reportar importación de producto controlado",
    component: () => <SustanciasReporte />,
  },
  {
    path: "/sustancia-reporte-medicamento-controlado",
    exact: true,
    title: "Sustancia reporte medicamento controlado",
    component: () => <SustanciaReporteControlado />,
  },
  {
    path: "/autorizacion-alimento-cuarentena",
    exact: true,
    title: "Autorización de alimentos",
    component: () => <AutorizacionAlimentosCuarentena />,
  },
  {
    path: "/reportes-main",
    exact: true,
    title: "Reportes",
    component: () => <ReportesMain />,
  },
  {
    path: "/descargar-app",
    exact: true,
    title: "Descargar apk APP Sinaip",
    component: () => <DescargarAPKAPP />,
  },
  {
    path: "/Visitas-fiscalizacion",
    exact: true,
    title: "Visitas fiscalización",
    component: () => <VisitDrycip />,
  },
  {
    path: "/Productos-Cuarentena",
    exact: true,
    title: "Productos",
    component: () => <ProductsCuarentena />
  }
];

export default routes;
